@for (user of users; track user) {
  <div class="row align-items-center mb-4">
    <div class="col-auto">
      <div class="avatar-with-badge" [class.is-project-manager]="user.IsManager" [class.is-moderator]="user.IsAdmin">
        <sc-avatar [user]="user"></sc-avatar>
        @if (user.IsManager) {
          <span class="badge badge-pill badge-dark">PM</span>
        }
        @if (user.IsAdmin && !user.IsDecider) {
          <span class="badge badge-pill badge-dark">M</span>
        }
        @if (user.IsDecider && !user.IsAdmin) {
          <span class="badge badge-pill badge-dark">E</span>
        }
        @if (user.IsDecider && user.IsAdmin) {
          <span class="badge badge-pill badge-dark">E/M</span>
        }
      </div>
    </div>
    <div class="col ms-n2 user-name-email">
      @if (user.FirstName || user.LastName) {
        <h6 class="mb-0 user-name">{{ user.FirstName }} {{ user.LastName }}
          @if (user.IsManager) {
            <span class="small text-muted fw-normal"> ({{ texts.projectManager[language] }})</span>
          }
          @if (user.IsAdmin && !user.IsDecider) {
            <span class="small text-muted fw-normal"> ({{ texts.moderator[language] }})</span>
          }
          @if (user.IsDecider && !user.IsAdmin) {
            <span class="small text-muted fw-normal"> ({{ texts.decider[language] }})</span>
          }
          @if (user.IsDecider && user.IsAdmin) {
            <span class="small text-muted fw-normal"> ({{ texts.deciderModerator[language] }})</span>
          }
        </h6>
      }
      @if (!user.FirstName && !user.LastName) {
        <h6 class="mb-0 user-name">{{ texts.notRegistered[language] }}</h6>
      }
      <p class="mb-0 user-mail small text-muted fw-normal">{{ user.EMail }}</p>
    </div>
    @if (user.canRemove && user.isAdded) {
      <div class="col-auto">
        <button class="btn btn-secondary btn-sm btn-circle" [title]="texts.removeParticipant[language]" [disabled]="user.isRemoving" (click)="remove(user)">
          @if (!user.isRemoving) {
            <span class="icon">
              <i class="fa-sharp fa-regular fa-xmark"></i>
            </span>
          }
          @if (user.isRemoving) {
            <span class="spinner-border spinner-border-sm"></span>
          }
        </button>
      </div>
    }
    @if (user.canAdd && !user.isAdded) {
      <div class="col-auto">
        <button class="btn btn-secondary btn-sm btn-circle" (click)="add(user)" [disabled]="user.isAdding">
          @if (!user.isAdding) {
            <span class="icon">
              <i class="fa-sharp fa-solid fa-user-plus"></i>
            </span>
          }
          @if (user.isAdding) {
            <span class="spinner-border spinner-border-sm"></span>
          }
        </button>
      </div>
    }
    @if (!user.canRemove && user.isAdded) {
      <div class="col-auto">
        @if (user.isAdded) {
          <button class="btn btn-dark btn-sm btn-circle">
            <span class="icon">
              <i class="fa-sharp fa-solid fa-check"></i>
            </span>
          </button>
        }
      </div>
    }
  </div>
}